import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Error503Component } from './error-503.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { GenericAlertComponent } from '../../../../gt2/components/generic-alert/generic-alert.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';
import { AppRoutesName } from '../../../../gt2/const/AppRoutesName';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ERROR_503,
    component: Error503Component,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ERROR_503,
    component: Error503Component,
  },
  {
    path: AppRoutesName.FR.ERROR_503,
    component: Error503Component,
  },
  {
    path: AppRoutesName.EN.ERROR_503,
    component: Error503Component,
  },
];

@NgModule({
  declarations: [Error503Component],
  imports: [
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    MatInputModule,
    GenericAlertComponent,
    TranslateModule.forRoot(),
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
  ],
})
export class Error503Module {}
